// // utils/scrollLock.ts
// let savedScrollY = 0;

// export const lockScroll = () => {
//     savedScrollY = window.scrollY; // save current scroll position
//     document.body.style.position = "fixed";
//     document.body.style.top = `-${savedScrollY}px`;
//     document.body.style.left = "0";
//     document.body.style.right = "0";
//     document.body.style.overflow = "hidden";
//     document.body.style.width = "100%"; // avoid horizontal jump
// };

// export const unlockScroll = () => {
//     document.body.style.position = "";
//     document.body.style.top = "";
//     document.body.style.left = "";
//     document.body.style.right = "";
//     document.body.style.overflow = "";
//     document.body.style.width = "";

//     window.scrollTo(0, savedScrollY); // restore to where user was
// };

// utils/scrollLock.ts
export const lockScroll = () => {
    document.documentElement.style.overflow = "visible"; // lock <html>
    document.body.style.overflow = "visible";            // lock <body>
};

export const unlockScroll = () => {
    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";
};


export const lockScrollNew = () => {
    document.documentElement.style.overflow = "hidden"; // Disable scroll on <html>
    document.body.style.overflow = "hidden";            // Disable scroll on <body>
};

export const unlockScrollNew = () => {
    document.documentElement.style.overflow = ""; // Reset <html> overflow (back to default)
    document.body.style.overflow = "";            // Reset <body> overflow (back to default)
};
